import { useState, useEffect } from "react";
import { WhatsappLogo, EnvelopeSimple, ArrowUp, ChatCircleDots, X } from "@phosphor-icons/react";
import { SITE } from "@/data/site";
import { useSettings } from "@/context/SettingsContext";

export default function FloatingActions() {
  const [showTop, setShowTop] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const { settings } = useSettings();
  const c = settings.contact || {};
  const emailHref = `mailto:${c.email || SITE.email}`;
  const whatsappHref = `https://wa.me/${c.whatsapp || SITE.whatsapp}`;

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed bottom-5 right-5 z-[55] flex flex-col items-end gap-3" data-testid="floating-actions">
      {chatOpen && (
        <div className="w-72 rounded-3xl border border-border bg-card p-5 shadow-soft-lg" data-testid="live-chat-box">
          <div className="flex items-center justify-between mb-3">
            <span className="font-bold">Live Chat</span>
            <button onClick={() => setChatOpen(false)} aria-label="Close chat"><X size={18} /></button>
          </div>
          <p className="text-sm text-muted-foreground">👋 Hi! Our team is here to help you find the perfect ebike. Message us on WhatsApp for an instant reply.</p>
          <a href={whatsappHref} target="_blank" rel="noreferrer" className="btn-primary w-full mt-4 !py-2.5 text-sm">Chat on WhatsApp</a>
        </div>
      )}

      {showTop && (
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="grid h-11 w-11 place-items-center rounded-full bg-foreground text-background shadow-soft-lg transition-transform hover:-translate-y-1" aria-label="Back to top" data-testid="back-to-top">
          <ArrowUp size={20} />
        </button>
      )}
      <a href={emailHref} className="grid h-12 w-12 place-items-center rounded-full bg-brand-gray text-white shadow-soft-lg transition-transform hover:-translate-y-1" aria-label="Email us" data-testid="email-us-btn">
        <EnvelopeSimple size={22} weight="fill" />
      </a>
      <button onClick={() => setChatOpen((s) => !s)} className="grid h-12 w-12 place-items-center rounded-full bg-foreground text-background shadow-soft-lg transition-transform hover:-translate-y-1" aria-label="Live chat" data-testid="live-chat-btn">
        <ChatCircleDots size={22} weight="fill" />
      </button>
      <a href={whatsappHref} target="_blank" rel="noreferrer" className="grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-glow transition-transform hover:-translate-y-1" aria-label="WhatsApp" data-testid="whatsapp-btn">
        <WhatsappLogo size={28} weight="fill" />
      </a>
    </div>
  );
}
